<template>
  <v-dialog :value="show" @input="onInput" max-width="600px">
    <v-card>
      <v-card-title class="d-flex flex-column align-start text-subtitle-1">
        <span>Чат: {{ getChatName() }}</span>
        <span>Админы в чате: {{ getSupportsInChat() }}</span>
        В чате уже есть админ. Вы уверены, что хотите открыть чат?
      </v-card-title>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('decline')">Нет</v-btn>
        <v-btn color="primary" dark @click="$emit('confirm', chatId)">OK</v-btn>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'EnterChatDialog',

  props: {
    show: {
      type: Boolean,
      require: true,
    },
    chatId: {
      type: Number,
      require: false,
    },
  },

  computed: {
    byId() {
      return this.$store.state.chat.byId;
    },

    supports() {
      return this.$store.state.support.supports;
    },
  },

  methods: {
    getChatName() {
      if (!this.chatId) return '';

      const chat = this.byId[this.chatId];
      const name = `${chat.from.first_name || ''} ${chat.from.last_name || ''}`;

      return name.trim() || chat.from.username || 'No name';
    },

    getSupportsInChat() {
      if (!this.chatId) return '';

      return this.supports
        .filter(support => support.activeChats.indexOf(this.chatId) >= 0)
        .map(support => support?.nickname || support?.email)
        .join(', ');
    },

    onInput(value) {
      if (value === false) {
        this.$emit('decline');
      }
    },
  },
};
</script>
